import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['', 'small'])
};
function ProductDetail(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? '' : _ref$variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "product-detail",
    "data-variant": variant || null
  }, children);
}
ProductDetail.propTypes = propTypes;

export { ProductDetail as default };
//# sourceMappingURL=ProductDetail.js.map
